import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'Depths',
    name: 'Horde-Crone',
    id: 'HordeCrone',
    health: 60,
    difficulty: 6,
    expeditionRating: 2,
    additionalInfo: '',
  },
]
